export default __webpack_public_path__ + "static/banner-3d32b0196df3ffb2d67837d448f6580c.svg";